import { Pipe, PipeTransform } from '@angular/core';
import { AssignmentBusinessUnitInfo, BusinessUnitFilterData } from '../models/identity';

@Pipe({
    name: 'businessUnitFilter'
})
export class BusinessUnitFilterPipe implements PipeTransform {

    transform(items: Array<AssignmentBusinessUnitInfo>, searchObject: BusinessUnitFilterData): Array<AssignmentBusinessUnitInfo> {
        if (items.length < 1) {
            return [];
        }
        return (!this.isSearchrequired(searchObject)) ? items : this.getSearchResult(items, searchObject);
    }

    private getSearchResult(items: Array<AssignmentBusinessUnitInfo>,
        searchObject: BusinessUnitFilterData): Array<AssignmentBusinessUnitInfo> {
        let searchResult: Array<AssignmentBusinessUnitInfo> = items;
        if (!!searchObject.displayName) {
            searchResult = searchResult
                .filter(it => it.displayName.includes(searchObject.displayName));
        }
        if (!!searchObject.assignBusinessUnitAdministratorsId) {
            searchResult = searchResult
                .filter(it => it.businessUnitAdministrators
                    .some(hr => hr.id === searchObject.assignBusinessUnitAdministratorsId));
        }
        if (searchObject.hasBusinessUnitAdministrator) {
            searchResult = searchResult
                .filter(it => it.businessUnitAdministrators.length === 0);
        }
        return Array.from(new Set(searchResult));
    }

    private isSearchrequired(searchObject: BusinessUnitFilterData): boolean {
        return !!searchObject.assignBusinessUnitAdministratorsId
            || !!searchObject.displayName
            || searchObject.hasBusinessUnitAdministrator;
    }
}
